/**
 * Created by Sushma Muppala in 2023
 */

import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import Combobox, { LabelPosition, Size } from "@ls/react-combobox-grid";
import { Scan2PercentilesOptions } from "state/selections/Constants/PercentileOptions";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";
import { selectScan2CalcTypeOptions } from "state/scan2/selectors";
import { Cell, Grid } from "styled-css-grid";



const Scan2SelectorComplication = ({ setDefinition, definition }) => {
  const scan2CalcTypeOptions = useSelector(selectScan2CalcTypeOptions);

  const [setPercentiles, setScan2CalcType, setSummary] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setPercentiles(value)),
      (value) => setDefinition(definition.setScan2CalcType(value)),
      (value) => setDefinition(definition.setSummary(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={3} gap="4px">
      <Cell width={1}>
        <Combobox
          label="Calc Type:"
          onChange={setScan2CalcType}
          options={scan2CalcTypeOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.scan2CalcType}
          placeholder="Calc Type..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      <Cell width={1}>
        <Combobox
          label="Percentiles:"
          onChange={setPercentiles}
          options={Scan2PercentilesOptions}
          labelPosition={LabelPosition.TOP}
          value={definition.percentiles}
          placeholder="Percentiles..."
          gridHeight={100}
          size={Size.S}
          variation={0}
        />
      </Cell>
      <Cell>
        <Combobox
          label="Abs/Rel:"
          onChange={setSummary}
          options={summaryTypeOptionsLegacy}
          value={definition.summary}
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={100}
        />
      </Cell>
    </Grid>
  );
};

export default memo(Scan2SelectorComplication);
